// Helper for rendering MongoDB values in tables. Handles objects (addresses),
// booleans, nullish, and everything else.
export const formatValueForDisplay = (value) => {
  if (value === null || value === undefined) {
    return '-';
  }
  if (typeof value === 'object') {
    if (value.street || value.city || value.state || value.zip) {
      const parts = [value.street, value.city, value.state, value.zip].filter(Boolean);
      return parts.join(', ') || '-';
    }
    try {
      return JSON.stringify(value);
    } catch {
      return '[Object]';
    }
  }
  if (typeof value === 'boolean') {
    return value ? 'Yes' : 'No';
  }
  return String(value);
};

export const formatDuplicateDate = (dateStr) => {
  if (!dateStr) return 'N/A';
  try {
    return new Date(dateStr).toLocaleDateString();
  } catch {
    return 'Invalid date';
  }
};

export const confidenceBadgeClass = (confidence) => {
  if (confidence >= 80) return 'bg-red-100 text-red-700 border-red-200';
  if (confidence >= 55) return 'bg-amber-100 text-amber-700 border-amber-200';
  return 'bg-slate-100 text-slate-700 border-slate-200';
};
